import { render, staticRenderFns } from "./OtherSection.vue?vue&type=template&id=484bc5a8&"
import script from "./OtherSection.vue?vue&type=script&lang=js&"
export * from "./OtherSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports